import { FormEventHandler, ReactNode } from "react";
import "./Form.scss";

type FormProps = {
  children: ReactNode;
  onSubmit: FormEventHandler<HTMLFormElement>;
  className?: string;
  noValidate?: boolean;
  id?: string;
};

function Form({
  children,
  onSubmit,
  className = "",
  noValidate = false,
  id,
}: FormProps) {
  return (
    <form
      id={id}
      className={`form ${className}`.trim()}
      onSubmit={onSubmit}
      noValidate={noValidate}
    >
      {children}
    </form>
  );
}

export default Form;
